import type { ComponentConfig } from '@measured/puck';
import { Container } from '../layout/Container';

export interface RelatedArticleEntry {
  slug: string;
  title: string;
  excerpt?: string;
}

export interface RelatedArticlesProps {
  title?: string;
  articles: RelatedArticleEntry[];
}

export function RelatedArticles({ title, articles }: RelatedArticlesProps) {
  if (articles.length === 0) return <></>;
  return (
    <section className="bg-white py-12">
      <Container>
        {title ? <h2 className="mb-6 text-2xl font-bold tracking-tightish">{title}</h2> : null}
        <div className="grid gap-4 md:grid-cols-3">
          {articles.map((a) => (
            <a
              key={a.slug}
              href={`/blog/${a.slug}`}
              className="rounded-xl border border-stone-200 p-5 transition hover:border-brand-300"
            >
              <p className="font-display text-base font-semibold">{a.title}</p>
              {a.excerpt ? <p className="mt-2 text-sm text-stone-600">{a.excerpt}</p> : null}
            </a>
          ))}
        </div>
      </Container>
    </section>
  );
}

export const RelatedArticlesConfig: ComponentConfig<RelatedArticlesProps> = {
  fields: {
    title: { type: 'text' },
    articles: {
      type: 'array',
      arrayFields: {
        slug: { type: 'text' },
        title: { type: 'text' },
        excerpt: { type: 'textarea' },
      },
      defaultItemProps: { slug: '', title: '' },
    },
  },
  defaultProps: { title: 'Aller plus loin', articles: [] },
  render: RelatedArticles,
};
